/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { MenuItem } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import _ from 'lodash';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import clsx from 'clsx';
// import custom component
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';

// import custom function
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  radioGroupLabelNamePlan,
  radioGroupLabelNameDisputes,
  radioGroupQuarterNameDisputes,
  rebateProgramLabelName,
  checkboxDisputeOverdue,
  checkboxDisputeContact,
  viewPortHeight_355,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import * as Constants from '../../../../SharedModules/AppConstants';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import {
  checkQuarterValidation,
  compareQtrs,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { getCheckBoxValue } from '../../InvoiceAudits/store/Actions';
import {
  getCommonDropdownList,
  getManufacturerList,
  dispatchManufacturerData,
  selectionList,
  getAssignedUsersList,
  handleErrorMessages,
  getHeaderDetails,
  statusType,
  dropdownUpdatedList,
  dispatchDisputeBodyDetails,
} from '../store/actions';
import { TableHeaderForManufacturer } from './gridComponents/tablehead';

const DisputesSearch = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const getRebateProgramList = useSelector(
    (state) => state.sharedState.DisputesReducer?.dropdown
  );
  const getAllManufacturerList = useSelector(
    (state) => state.sharedState.DisputesReducer?.manufacturerList
  );
  const getAssignedToUsersList = useSelector(
    (state) => state.sharedState.DisputesReducer?.assignedToUsers
  );
  const getSelectionList = useSelector(
    (state) => state.sharedState.DisputesReducer?.selection_list
  );
  const getPlanTypeData = useSelector(
    (state) => state.sharedState.InvoiceAuditsReducer?.checkbox
  );
  const errorMessagesFromRedux = useSelector(
    (state) => state?.sharedState?.DisputesReducer?.errorMessagesInRedux
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const getManufacturerListValue = (values) =>
    dispatch(getManufacturerList(values));

  // variable declaration
  const gridRef = React.useRef();
  const [assignedUserList, setAssignedUsersList] = useState([]);
  const [dropdownList, setDropDownList] = useState([]);
  const [planTypeOptions, setPlanTypeOptions] = useState([]);
  const [rebateProgramList, setRebateProgramList] = useState([]);
  const [manufacturerList, setManufacturerList] = useState([]);
  const [paramsStore, setParamsStore] = React.useState();
  const [fullScreenView, setFullScreenView] = useState(false);
  const optionList = [
    { name: 'All Assigned', value: 'ASSIGNED' },
    { name: 'Assigned To', value: 'USER' },
    { name: 'Unassigned', value: 'UNASSIGNED' },
    { name: 'All', value: 'ALL' },
  ];
  const quarterList = [
    { name: 'All', value: 'AQ' },
    { name: 'Selected Range', value: 'SELECTED' },
  ];
  const getDefaultState = () => ({
    planTypeCd: userDefaults?.planTypeCd ? userDefaults?.planTypeCd : 'FD',
    rebateProgramCd: userDefaults?.rebateProgramCd
      ? userDefaults?.rebateProgramCd
      : '-1',
    manufacturers: true,
    manufacturerData: [],
    assignments: 'ASSIGNED',
    assignedTo: '-1',
    quarterRange: 'AQ',
    Open: true,
    Closed: false,
    allDisputeContact: false,
    overdueOnly: false,
    quarterFrom: null,
    quarterTo: null,
    status: '',
    showAllCorrespondence: false,
    paginateIndex: 1,
    statusNdcMaintain: '',
  });

  const [state, setState] = useState(() => {
    const defaultState = getDefaultState();
    if (getSelectionList) {
      return {
        ...getSelectionList,
        quarterRange: 'AQ',
        quarterFrom: null,
        quarterTo: null,
      };
    }
    return defaultState;
  });

  // on scroll default top level
  const handleScrollToEvent = () => {
    window.scrollTo(0, 0);
  };

  React.useEffect(() => {
    if (state?.assignedTo) {
      let result = dispatch(getAssignedUsersList());
      result.then((resp) => {
        setAssignedUsersList(resp);
      });
    }
  }, []);
 
  // handle all plan type get service on page load
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(handleErrorMessages([]));
    if (getSelectionList) {
      dispatch(
        selectionList({
          ...getSelectionList,
          quarterRange: 'AQ',
          quarterFrom: null,
          quarterTo: null,
        })
      );
    }
   
   
    if (!getPlanTypeData?.PLAN_TYPE_CD) {
      dispatch(getCheckBoxValue('PLAN_TYPE_CD'));
    }
    return()=>{
      dispatch(handleErrorMessages([]));

    }
  }, []);

  // set plan type list`
  React.useEffect(() => {
    const planList =
      getPlanTypeData &&
      getPlanTypeData.PLAN_TYPE_CD &&
      getPlanTypeData.PLAN_TYPE_CD.length > 0 &&
      getPlanTypeData.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj?.codeValueID?.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
    if (Array.isArray(planList) && planList.length > 0) {
      setPlanTypeOptions(planList);
    }
  }, [getPlanTypeData]);

  // set common dropdown list
  React.useEffect(() => {
    let result = dispatch(getCommonDropdownList(state.planTypeCd));
    result.then((resp) => {
      setDropDownList(resp);
    });
  }, [state.planTypeCd]);

  React.useEffect(() => {
    let list = [];
    if (
      dropdownList?.status === constantMessageData.STATUS_MSG &&
      dropdownList?.message === constantMessageData.SUCCESS_MSG
    ) {
      if (!_.isEmpty(dropdownList.data)) {
        list = _.map(dropdownList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
    dispatch(
      dropdownUpdatedList(
        list.sort((key, val) =>
          key.name.toLowerCase().localeCompare(val.name.toLowerCase())
        )
      )
    );
  }, [dropdownList]);

  // handling highlight tab
  React.useEffect(() => {
    if (errorMessagesFromRedux && errorMessagesFromRedux.length > 0) {
      tabHighLigther('/disputes', true);
    } else {
      tabHighLigther('/disputes', false);
    }
  }, [errorMessagesFromRedux]);

  // Fetch manufacturer list on mount and when plan type changes while unchecked
  React.useEffect(() => {
    if (state.manufacturers !== true && state.planTypeCd) {
      getManufacturerListValue({
        planTypeCd: state.planTypeCd,
      });
    }
  }, [state.planTypeCd, state.manufacturers]);

  // Sync manufacturer grid data when checkbox state or redux data changes
  React.useEffect(() => {
    if (state.manufacturers !== true && getAllManufacturerList?.length > 0) {
      setManufacturerList(getAllManufacturerList);
    } else if (state.manufacturers === true) {
      setManufacturerList([]);
    }
  }, [getAllManufacturerList, state.manufacturers]);

  // handling by default multiple row selection function
  const onGridReady = (params) => {
    setParamsStore(params);
    if (getAllManufacturerList && getAllManufacturerList?.length > 0) {
      params.api.forEachNode(
        (node) =>
          node.rowIndex ===
            getAllManufacturerList.findIndex((x) => {
              return x.mfgId === node.data.mfgId && x.value;
            }) && node.setSelected(true)
      );
      const getIndex = getAllManufacturerList.findIndex((x) => {
        return x.value;
      });
      if (getIndex === -1) {
        const newObj = getAllManufacturerList?.map((item, index) => {
          if (index === 0) {
            item.value = true;
          } else {
            item.value = false;
          }
          return item;
        });
        setManufacturerList(newObj);
        params.api.forEachNode(
          (node) => node.rowIndex === 0 && node.setSelected(true)
        );
      }
    }
  };

  // handling On change event on field level
  const handleOnChangeEvent = (value, name) => {
    let localErr = Array.isArray(errorMessagesFromRedux)
      ? [...errorMessagesFromRedux]
      : [];
    localErr = localErr?.filter(
      (item) => item.field !== 'search' && item.field !== 'manufacturerData'&&item.message !== constantMessageData.MNFC_NDC_ERROR_MSG
    );

    if (name === 'rebateProgramCd') {
      localErr = localErr?.filter((item) => item.field !== 'rebateProgramCd');

      setState({
        ...state,
        [name]: value,
      });
    } else if (name === 'planTypeCd') {
      setState({
        ...state,
        [name]: value,
        rebateProgramCd: '-1',
      });
    } else if (name === 'manufacturers') {
      setState({
        ...state,
        [name]: value,
      });

      if (value === false) {
        getManufacturerListValue({
          planTypeCd: state.planTypeCd,
        });
      } else {
        dispatch(dispatchManufacturerData([]));
      }
    } else if (name === 'assignments') {
      localErr = localErr?.filter((item) => item.field !== 'assignments');

      setState({
        ...state,
        [name]: value,
      });

      if (value === 'USER') {
        let result = dispatch(getAssignedUsersList());

        result.then((resp) => {
          setAssignedUsersList(resp);
        });
      }
    } else if (name === 'assignedTo') {
      localErr = localErr?.filter((item) => item.field !== 'assignments');

      setState({
        ...state,
        [name]: value,
      });
    } else if (name === 'quarterRange') {
      localErr = localErr?.filter(
        (item) => item.field !== 'quarterFrom' && item.field !== 'quarterTo'
      );
      dispatch(handleErrorMessages(localErr));
      if (value === 'AQ') {
        const updatedState = {
          ...state,
          quarterRange: value,
          quarterFrom: null,
          quarterTo: null,
        };

        setState(updatedState);

        dispatch(selectionList(updatedState));
      } else {
        setState({
          ...state,
          quarterRange: value,
        });
      }
    } else {
      setState({
        ...state,
        [name]: value,
      });
    }

    dispatch(handleErrorMessages([...new Set(localErr)]));
  };

  React.useEffect(() => {
    if (state?.rebateProgramCd && state?.rebateProgramCd !== '-1') {
      let localErr = Array.isArray(errorMessagesFromRedux)
        ? [...errorMessagesFromRedux]
        : [];

      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      dispatch(handleErrorMessages(localErr));
    }
  }, [state?.rebateProgramCd]);
  // handling On blur event on filed level
  const handleOnblurEvent = (type, value) => {
    let localErr = Array.isArray(errorMessagesFromRedux)
      ? [...errorMessagesFromRedux]
      : [];

    localErr = localErr?.filter(
      (item) => item.field !== 'search' && item.field !== 'manufacturerData'
    );
    if (type === 'rebateProgramCd') {
      if (!value || value === '-1') {
        localErr = localErr?.filter((item) => item.field !== 'rebateProgramCd');
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED_REQ,
        });
      } else {
        localErr = localErr?.filter((item) => item.field !== 'rebateProgramCd');
      }
    }
    if (type === 'quarterFrom' || type === 'quarterTo') {
      if (state.quarterRange !== 'SELECTED') {
        localErr = localErr?.filter(
          (item) => item.field !== 'quarterFrom' && item.field !== 'quarterTo'
        );
        dispatch(handleErrorMessages(localErr));
        return;
      }
      if (value && !_.isEmpty(value) && !_.isNaN(value)) {
        if (checkQuarterValidation(value)) {
          if (type === 'quarterFrom') {
            localErr = localErr?.filter((item) => item.field !== 'quarterFrom');
          }
          if (type === 'quarterTo') {
            localErr = localErr?.filter((item) => item.field !== 'quarterTo');
          }
          const formattedValue = autoFormateDate(value?.toUpperCase());
          setState({
            ...state,
            [type]: formattedValue,
          });
          dispatch(
            selectionList({
              ...state,
              [type]: formattedValue,
            })
          );
          const fromQuarter =
            type === 'quarterFrom' ? formattedValue : state?.quarterFrom;
          const toQuarter =
            type === 'quarterTo' ? formattedValue : state?.quarterTo;
          if (
            checkQuarterValidation(fromQuarter) &&
            checkQuarterValidation(toQuarter)
          ) {
            if (compareQtrs(fromQuarter, toQuarter)) {
              localErr.push({
                field: type,
                errorType: 'rangeInvalid',
                message: constantMessageData.QTR_VALIDATION_ERR,
              });
            } else {
              localErr = localErr?.filter(
                (item) => item.errorType !== 'rangeInvalid'
              );
            }
          }
        } else {
          localErr = localErr?.filter((item) => item.field !== type);
          localErr.push({
            field: type,
            errorType: 'invalidFormat',
            message: constantMessageData.VALIDATE_QUARTER_VALUE,
          });
        }
      } else {
        localErr = localErr?.filter((item) => item.field !== type);
        if (type === 'quarterFrom' && state.quarterRange === 'SELECTED') {
          localErr.push({
            field: type,
            errorType: 'quarterFromRequired',
            message: constantMessageData.DISPUTES_START_QTR,
          });
        }
      }
    }
    dispatch(handleErrorMessages([...new Set(localErr)]));
  };

  // handing full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  const cellClickedListener = (val) => {
    const [selectedRows] = val.api.getSelectedRows();

    searchDisputeData({
      ...state,
      manufacturerData: [selectedRows.mfgId],
    });
  };
  // select row one by one in manufacturer table grid
  const onRowSelect = (rowData) => {
    setState({ ...state, manufacturerData: rowData });
    const newObj = getAllManufacturerList?.map((item) => {
      if (
        rowData?.filter((x) => {
          return x.mfgId === item.mfgId;
        }).length > 0
      ) {
        item.value = true;
      } else {
        item.value = false;
      }
      return item;
    });
    dispatch(dispatchManufacturerData(newObj));
  };

  // function to handle searched disputes on the basis of parameters
  const searchDisputeData = async (formData) => {
    let localErr = [];
    const sendManuf = [];
    const getManuf = getAllManufacturerList?.filter((x) => {
      if (x.value === true) {
        sendManuf.push(x.mfgId);
        return x;
      }
      return false;
    });
    if (getManuf?.length === 0 && formData.manufacturers === false) {
      localErr.push({
        field: 'manufacturerData',
        errorType: 'manufacturerRequired',
        message:
          constantMessageData.ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
      });
    }
    if (!formData.rebateProgramCd || formData.rebateProgramCd === '-1') {
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: constantMessageData.REBATE_PROGRAM_REQUIRED_REQ,
      });
    }

    if (formData.assignments === 'USER' && formData.assignedTo === '-1') {
      localErr.push({
        field: 'assignments',
        errorType: 'assignmentRequired',
        message: constantMessageData.ASSIGNMENT_REQUIRED,
      });
    }

    if (formData.quarterRange === 'SELECTED') {
      if (!formData.quarterFrom || formData.quarterFrom.trim() === '') {
        localErr.push({
          field: 'quarterFrom',
          errorType: 'quarterFromRequired',
          message: constantMessageData.CONTRACT_START_QTR,
        });
      } else if (!checkQuarterValidation(formData.quarterFrom)) {
        localErr.push({
          field: 'quarterFrom',
          errorType: 'invalidFormat',
          message: constantMessageData.VALIDATE_QUARTER_VALUE,
        });
      }

      if (formData.quarterTo && formData.quarterTo.trim() !== '') {
        if (!checkQuarterValidation(formData.quarterTo)) {
          localErr.push({
            field: 'quarterTo',
            errorType: 'invalidFormat',
            message: constantMessageData.VALIDATE_QUARTER_VALUE,
          });
        } else if (
          checkQuarterValidation(formData.quarterFrom) &&
          compareQtrs(formData.quarterFrom, formData.quarterTo)
        ) {
          localErr.push({
            field: 'quarterTo',
            errorType: 'rangeInvalid',
            message: constantMessageData.QTR_VALIDATION_ERR,
          });
        }
      }
    }

    if (localErr.length > 0) {
      dispatch(handleErrorMessages(localErr));

      window.scrollTo(0, 0);

      return;
    }

    dispatch(handleErrorMessages([]));

    let status = 'A';

    if (formData.Open === true && formData.Closed === true) {
      status = 'A';
    } else if (formData.Open === true) {
      status = 'O';
    } else if (formData.Closed === true) {
      status = 'C';
    }

    let quarterFrom = formData.quarterFrom;
    let quarterTo = formData.quarterTo;

    if (formData.quarterRange === 'AQ') {
      quarterFrom = null;
      quarterTo = null;
    } else {
      if (!quarterTo && quarterFrom) {
        quarterTo = quarterFrom?.toUpperCase();
      }
    }

    const payload = {
      allQtr: formData.quarterRange === 'AQ' ? 'Y' : 'N',
      fromQtr: quarterFrom,
      toQtr: quarterTo,
      status: status,
      assignment: formData.assignments,
      secUserId: formData.assignments === 'USER' ? formData.assignedTo : null,
      overdue: formData.overdueOnly === true ? 'Y' : 'N',
      allMfg: formData.manufacturers === true ? 'Y' : 'N',
      mfgIdList: sendManuf,
      allRpc: formData.rebateProgramCd === 'ALL' ? 'Y' : 'N',
      rpcInput:
        formData.rebateProgramCd === 'ALL' ? null : formData.rebateProgramCd,
      planTypeCd: formData.planTypeCd,
      showAllDisputesForDisputeContact:
        formData.allDisputeContact === true ? 'Y' : 'N',
    };

    const getData = await dispatch(getHeaderDetails(payload));

    if (getData?.payload?.disputeDetailsHeader?.length > 0) {
      dispatch(dispatchDisputeBodyDetails([]));

      dispatch(
        selectionList({
          ...formData,
          manufacturerData: sendManuf,
          status,
          quarterFrom,
          quarterTo,
        })
      );

      dispatch(
        statusType({
          open: formData.Open,
          closed: formData.Closed,
        })
      );

      moveToDetails();
    } else {
      dispatch(
        handleErrorMessages([
          {
            field: 'search',
            errorType: 'noResults',
            message: constantMessageData.MNFC_NDC_ERROR_MSG,
          },
        ])
      );

      window.scrollTo(0, 0);
    }
  };

  // function to navigate to dispute detail screen
  const moveToDetails = () => {
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/disputesDetails',
      value: 'View Disputes Details',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    props.history.push({
      pathname: '/disputesDetails',
    });
  };

  return (
    <div
      className="tabs-container frr-research-dispute"
      data-testid="disputes-search"
    >
      <CustomSeparator parent1="Research" parent2="Disputes" />
      {!fullScreenView && (
        <>
          <DisplayErrorMessages
            errorMessages={[
              ...new Set(
                errorMessagesFromRedux?.length > 0
                  ? _.map(
                      errorMessagesFromRedux?.filter((item) => {
                        // hide quarter errors when AQ selected
                        if (
                          state?.quarterRange === 'AQ' &&
                          (item.field === 'quarterFrom' ||
                            item.field === 'quarterTo')
                        ) {
                          return false;
                        }

                        return true;
                      }),
                      (l) => l.message
                    )
                  : []
              ),
            ]}
          />

          <Spinner load={spinnerLoader} />
        </>
      )}
      {!fullScreenView && (
        <>
          <div className="row mb-2">
            <div className="col-12 col-sm-12 col-md-5 frr-two-col-radio">
              <RadioGroupComponent
                data-testid="filter-plan-by-radio-btn-plan"
                id="filter-plan-by-radio-btn-action"
                labelName={radioGroupLabelNamePlan}
                required
                reqColor
                optionList={planTypeOptions}
                defaultValue={state && state.planTypeCd}
                filterAction={(e) => {
                  handleOnChangeEvent(e, 'planTypeCd');
                }}
                className="log-batch-filter-radio frr-checkInvoiceRadio"
              />
            </div>
            <div className="col-12 col-sm-12 col-md-7 frr-two-col-radio frr-mt-9">
              <fieldset
                data-testid="radio-box-component"
                className="custom-fieldset"
              >
                <legend aria-hidden="true" className="d-none" />
                <div className="row">
                  <div className="col-6">
                    <div className="mui-custom-form with-select">
                      <TextField
                        className="mandate-fields"
                        data-testid="rebate_program-ia"
                        id="rebate_program"
                        label={rebateProgramLabelName}
                        fullWidth
                        select
                        required
                        placeholder=""
                        inputProps={{ maxLength: 11, id: 'rebate_program' }}
                        onBlur={(e) =>
                          handleOnblurEvent('rebateProgramCd', e.target.value)
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={state && state.rebateProgramCd}
                        onChange={(e) =>
                          handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                        }
                        helperText={
                          errorMessagesFromRedux?.length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter((x) => {
                                      return x.field === 'rebateProgramCd';
                                    })
                                    .map((item) => {
                                      return item.message;
                                    })
                                ),
                              ]
                            : null
                        }
                        error={
                          errorMessagesFromRedux?.length > 0 &&
                          errorMessagesFromRedux?.filter((x) => {
                            return x.field === 'rebateProgramCd';
                          }).length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter((x) => {
                                      return x.field === 'rebateProgramCd';
                                    })
                                    .map((item) => {
                                      return item.message;
                                    })
                                ),
                              ]
                            : false
                        }
                      >
                        <MenuItem
                          key=""
                          value=""
                          className="frr-dropdown-blank-item"
                        >
                          {''}
                        </MenuItem>
                        <MenuItem key="ALL" value="ALL">
                          All Rebate Programs
                        </MenuItem>
                        {rebateProgramList &&
                        rebateProgramList.length &&
                        rebateProgramList.length > 0
                          ? rebateProgramList.map((item) => {
                              return (
                                <MenuItem
                                  key={item.id}
                                  value={item.id}
                                  className="frr-logcheck-dropdown-item"
                                >
                                  {item.name}
                                </MenuItem>
                              );
                            })
                          : null}
                      </TextField>
                    </div>
                  </div>
                  <div className="col-6">
                    <FormControlLabel
                      className="ml-0 frr-mt-37"
                      data-testid="manufacturer_checked_ia"
                      control={<Checkbox color="primary" className="" />}
                      label="All&nbsp;Manufacturers"
                      value={state.manufacturers}
                      checked={state?.manufacturers}
                      onChange={(e) => {
                        if (e.target.checked !== undefined) {
                          handleOnChangeEvent(
                            e.target.checked,
                            'manufacturers'
                          );
                        }
                      }}
                    />
                  </div>
                </div>
              </fieldset>
            </div>
          </div>

          <div className="row frr-dispute-search">
            <div className="col-12 col-sm-8 col-lg-9 col-xl-10 frr-two-col-radio position-relative">
              <fieldset
                data-testid="radio-box-component"
                className="radioBtnGroup custom-fieldset h-100"
              >
                <legend className="same-font-family">
                  {radioGroupLabelNameDisputes}{' '}
                </legend>
                <div className="col-12 col-lg-7 pl-0">
                  <div className="form-wrapper db">
                    <div className="sub-radio no-margin">
                      <FormControl>
                        <RadioGroup
                          row
                          name="assignments-radio"
                          defaultValue={state && state.assignments}
                          value={state && state.assignments}
                          data-testid="assignments-radio-box-group-control"
                        >
                          {!_.isEmpty(optionList)
                            ? optionList?.map((v, i) => (
                                <FormControlLabel
                                  value={v.value}
                                  control={
                                    <Radio
                                      onChange={(e) =>
                                        handleOnChangeEvent(
                                          v.value,
                                          'assignments'
                                        )
                                      }
                                      data-testid="radio-child-group-control"
                                    />
                                  }
                                  label={v.name}
                                  key={v.value && _.kebabCase(v.value)}
                                />
                              ))
                            : null}
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>
                </div>

                <div className="mui-custom-form with-select frr-assignTo-position">
                  <TextField
                    data-testid="assigned-to"
                    className="mandate-fields frr-display-hidden-label"
                    id="assigned_to"
                    label="assign To"
                    fullWidth
                    select
                    required
                    placeholder=""
                    inputProps={{ maxLength: 11, id: 'assigned_to' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={state?.assignments !== 'USER'}
                    value={state && state.assignedTo}
                    onChange={(e) =>
                      handleOnChangeEvent(e.target.value, 'assignedTo')
                    }
                    helperText={
                      errorMessagesFromRedux?.length > 0
                        ? [
                            ...new Set(
                              errorMessagesFromRedux
                                ?.filter((x) => {
                                  return x.field === 'assignments';
                                })
                                .map((item) => {
                                  return item.message;
                                })
                            ),
                          ]
                        : null
                    }
                    error={
                      errorMessagesFromRedux?.length > 0 &&
                      errorMessagesFromRedux?.filter((x) => {
                        return x.field === 'assignments';
                      }).length > 0
                        ? [
                            ...new Set(
                              errorMessagesFromRedux
                                ?.filter((x) => {
                                  return x.field === 'assignments';
                                })
                                .map((item) => {
                                  return item.message;
                                })
                            ),
                          ]
                        : false
                    }
                  >
                    <MenuItem
                      key=""
                      value="-1"
                      className="frr-dropdown-blank-item"
                    />
                    {assignedUserList?.length > 0
                      ? assignedUserList.map((item) => {
                          return (
                            <MenuItem
                              key={item.userId}
                              value={item.userId}
                              className="frr-logcheck-dropdown-item"
                            >
                              {item.lastName}, {item.firstName} | {item.userId}
                            </MenuItem>
                          );
                        })
                      : null}
                  </TextField>
                </div>
              </fieldset>
            </div>
            <div className="col-12 col-sm-4 col-lg-3 col-xl-2 frr-checkbox-100per-width">
              <fieldset className="custom-fieldset h-100 frr-checkboxBtnGroup">
                <legend>Status</legend>
                <div className="form-wrapper db">
                  <FormControlLabel
                    data-testid="status_checked_open_ia"
                    control={<Checkbox color="primary" className="" />}
                    label="Open"
                    value={state.Open}
                    checked={state.Open}
                    onChange={(e) =>
                      handleOnChangeEvent(e.target.checked, 'Open')
                    }
                  />
                  <FormControlLabel
                    data-testid="status_checked_closed_ia"
                    control={<Checkbox color="primary" className="" />}
                    label="Closed"
                    value={state.Closed}
                    checked={state.Closed}
                    onChange={(e) =>
                      handleOnChangeEvent(e.target.checked, 'Closed')
                    }
                  />
                </div>
              </fieldset>
            </div>
          </div>

          <div className="row">
            <div className="col-5 col-sm-5 mt-2">
              <fieldset
                data-testid="radio-box-component"
                className="radioBtnGroup custom-fieldset h-100"
              >
                <legend className="same-font-family">
                  {radioGroupQuarterNameDisputes}{' '}
                </legend>
                <div className="form-wrapper db">
                  <div className="sub-radio no-margin">
                    <FormControl>
                      <RadioGroup
                        row
                        name="quarter-radio"
                        defaultValue={state && state.quarterRange}
                        value={state && state.quarterRange}
                        data-testid="quarter-radio-box-group-control"
                      >
                        {!_.isEmpty(quarterList)
                          ? quarterList.map((v, i) => (
                              <FormControlLabel
                                value={v.value}
                                control={
                                  <Radio
                                    onChange={(e) =>
                                      handleOnChangeEvent(
                                        v.value,
                                        'quarterRange'
                                      )
                                    }
                                  />
                                }
                                label={v.name}
                                key={v.value && _.kebabCase(v.value)}
                              />
                            ))
                          : null}
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
                <div className="row custom-search-dates mt-3">
                  <div className="col-6">
                    <div className="heading">From</div>
                    <div className="mui-custom-textField input-md w-100">
                      <TextField
                        className="mandate-fields"
                        data-testid="check_From_Date"
                        id="checkFromDate"
                        label="From"
                        fullWidth
                        placeholder=""
                        disabled={state?.quarterRange === 'AQ'}
                        inputProps={{ maxLength: 6 }}
                        value={state?.quarterFrom}
                        onChange={(e) =>
                          handleOnChangeEvent(e.target.value, 'quarterFrom')
                        }
                        onBlur={(e) =>
                          handleOnblurEvent(
                            'quarterFrom',
                            e.target.value?.toUpperCase()
                          )
                        }
                        helperText={
                          state?.quarterRange === 'SELECTED' &&
                          errorMessagesFromRedux?.length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter((x) => x.field === 'quarterFrom')
                                    ?.map((item) => item.message)
                                ),
                              ]
                            : null
                        }
                        error={
                          state?.quarterRange === 'SELECTED' &&
                          errorMessagesFromRedux?.length > 0 &&
                          errorMessagesFromRedux?.filter((x) => {
                            return x.field === 'quarterFrom';
                          }).length > 0
                        }
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="heading">To</div>
                    <div className="mui-custom-textField input-md w-100">
                      <TextField
                        className="mandate-fields"
                        data-testid="check_To_Date"
                        id="checkToDate"
                        label="To"
                        fullWidth
                        placeholder=""
                        disabled={state?.quarterRange === 'AQ'}
                        inputProps={{ maxLength: 6 }}
                        value={state?.quarterTo}
                        onChange={(e) =>
                          handleOnChangeEvent(e.target.value, 'quarterTo')
                        }
                        onBlur={(e) =>
                          handleOnblurEvent(
                            'quarterTo',
                            e.target.value?.toUpperCase()
                          )
                        }
                        helperText={
                          state?.quarterRange === 'SELECTED' &&
                          errorMessagesFromRedux?.length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter((x) => {
                                      return x.field === 'quarterTo';
                                    })
                                    ?.map((item) => {
                                      return item.message;
                                    })
                                ),
                              ]
                            : null
                        }
                        error={
                          state?.quarterRange === 'SELECTED' &&
                          errorMessagesFromRedux?.length > 0 &&
                          errorMessagesFromRedux?.filter((x) => {
                            return x.field === 'quarterTo';
                          }).length > 0
                        }
                      />
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>

            <div className="col-5 col-sm-7 mt-2 frr-pt-37">
              <FormControlLabel
                data-testid="checked_ia"
                control={<Checkbox color="primary" className="" />}
                label={checkboxDisputeContact}
                value={state.allDisputeContact}
                checked={state.allDisputeContact}
                disabled={state.manufacturers === true}
                onChange={(e) =>
                  handleOnChangeEvent(e.target.checked, 'allDisputeContact')
                }
              />
              <FormControlLabel
                data-testid="checked_ia"
                control={<Checkbox color="primary" className="" />}
                label={checkboxDisputeOverdue}
                value={state.overdueOnly}
                checked={state.overdueOnly}
                onChange={(e) =>
                  handleOnChangeEvent(e.target.checked, 'overdueOnly')
                }
              />
            </div>
          </div>

          <div className="text-right">
            <Button
              className="btn btn-success btn-search"
              data-testid="view_detail_ia"
              type="button"
              onClick={() => {
                searchDisputeData(state);
              }}
            >
              {' '}
              <SVGComponent iconName="Icon-search" /> {'  '} Search
            </Button>
          </div>
        </>
      )}
      <div
        id="testGrid"
        className="panel-body FRR-custom-table tbl-manufacturer-inner"
      >
        {state.manufacturers !== true ? (
          <TableGrid
            ref={gridRef}
            data-testid="manufacturer-disputes-table"
            rowSelection="multiple"
            gridCall={onGridReady}
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            // eslint-disable-next-line camelcase
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            rowData={manufacturerList?.sort((a, b) => a.mfgId - b.mfgId)}
            onSelect={(e) => onRowSelect(e.api?.getSelectedRows())}
            cellClickedListener={cellClickedListener}
            columnDefs={TableHeaderForManufacturer}
            exportFile
            animateRows
            sideBar={false}
            fileName="Disputes-Manufacturer"
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            helpMessage={Constants.DOUBLE_CLICK_INFO}
          />
        ) : null}
      </div>
    </div>
  );
};
export default DisputesSearch;
